import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { rejectReasons } from "@/mocks/home";

export default function RejectSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="reject" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <SectionHeading
                eyebrow="审核不通过原因"
                title="审核不通过，多半是踩了这几个坑"
                desc="提前避开这些常见问题，能显著提高线索被采纳的概率。点击每条查看原因与改进方式。"
              />
            </div>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {rejectReasons.map((item, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={item.title}
                  className={`rounded-lg border overflow-hidden transition-colors ${
                    open ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-100"
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? null : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left hover:bg-background-200/50 transition-colors"
                  >
                    <span className="flex items-center gap-3">
                      <span className="w-7 h-7 shrink-0 rounded-full bg-accent-100 text-accent-700 text-xs font-bold flex items-center justify-center">
                        {index + 1}
                      </span>
                      <span className="font-medium text-sm md:text-base text-foreground-950">
                        {item.title}
                      </span>
                    </span>
                    <i
                      className={`text-xl text-foreground-500 shrink-0 transition-transform ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {open && (
                    <div className="px-5 md:px-6 pb-5 pt-0">
                      <p className="text-sm text-foreground-600 leading-relaxed pl-10">
                        {item.detail}
                      </p>
                      <p className="mt-3 text-sm text-secondary-800 leading-relaxed pl-10 flex items-start gap-2">
                        <i className="ri-tools-line mt-0.5 shrink-0"></i>
                        {item.fix}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}